import React from "react";
import s from "../checklists.less";
interface ICardProps {
  title: string;
  count?: number;
  className?: string;
  href?: string;
}
const ActionPlanCard: React.FC<ICardProps> = ({
  title,
  count,
  className,
  href,
}) => (
  <div className={className}>
    <div className={s.inner}>
      <div className={s.cardTitle}>{title}</div>
      {href ? (
        <a href={href}>DNM</a>
      ) : (
        <div className={s.cardCount}>{count}</div>
      )}
    </div>
  </div>
);

export default ActionPlanCard;
